import { render, staticRenderFns } from "./priSettingsDepartmentsPage.vue?vue&type=template&id=e0f4d444"
import script from "./priSettingsDepartmentsPage.vue?vue&type=script&lang=js"
export * from "./priSettingsDepartmentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports